import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, FloatImage, Heading, Image, RawButton, Responsive, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import logoImage from '@/assets/login-logo.svg';
import SidebarIllustration from '@/assets/placeholders/signup-sidebar.svg';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';
import { THEMES } from '@/utils/whiteLabeling/whiteLabelingConfig';

const Wrapper = styled(Box)`
  position: relative;
  background: ${({ theme }) => theme.colors.navigationBackground || theme.colors.fade2};
  color: ${({ theme }) => theme.colors.navigationTextDefault};
`;

interface SidebarProps {
  onSignInRedirect?: () => void;
  isMobileView?: boolean;
}
const isNationwideTheme = whiteLabelingConfig.key === THEMES.nationwide;
const Sidebar: React.FC<SidebarProps> = ({ onSignInRedirect, isMobileView }) => {
  const { t } = useTranslation();

  return (
    <Wrapper
      direction="column"
      width={{ min: 'stepperSize' }}
      style={{
        position: 'relative',
      }}
    >
      <Box
        fill
        align="start"
        pad={{
          horizontal: isMobileView ? 'spacing16' : 'spacing32',
          vertical: 'spacing32',
        }}
        style={{
          zIndex: 100,
        }}
      >
        <RawButton
          type="button"
          data-testid="SignUp-Sidebar-Logo-testid"
          aria-label={t('Go to Welcome page')}
          onClick={onSignInRedirect}
        >
          <Image
            src={
              (whiteLabelingConfig?.images?.sidebarLogo as string) ||
              (whiteLabelingConfig?.logo as string) ||
              (logoImage as unknown as string)
            }
            alt="logo"
            alignSelf="start"
            height={40}
          />
        </RawButton>
        <Box direction="row" align="center" margin={{ top: 'spacing12' }}>
          <Text size="large" color="navigationTextDefault">
            {t('Already a member? ')}
          </Text>
          <Box pad={{ left: 'spacing4' }}>
            <Button size="small" empty style={{ fontWeight: 'bold' }} onClick={onSignInRedirect}>
              <Text size="large" color="navigationAccent2">
                {t('Sign In')}
              </Text>
            </Button>
          </Box>
        </Box>
        {!isNationwideTheme && (
          <Responsive sizes={[Responsive.Desktop, Responsive.Tablet]}>
            <Box margin={{ top: 'spacing32' }}>
              <Heading level={4} size="24px" color="navigationTextDefault">
                {t('Register to Get Going!')}
              </Heading>
            </Box>
          </Responsive>
        )}
      </Box>

      <FloatImage
        className="placeholder"
        src={whiteLabelingConfig?.images?.signUpSidebar || SidebarIllustration}
        fit="contain"
        style={
          isMobileView
            ? {
                right: 0,
                objectPosition: 'right bottom',
              }
            : {
                left: 0,
                right: 0,
                objectPosition: 'center bottom',
              }
        }
      />
    </Wrapper>
  );
};
export default Sidebar;
